import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import PublicRoutesLayout from "./components/shared/publicRoutesLayout";
import Login from "./components/login/login";
import DashboardLayout from "./components/shared/dashboardLayout";
import Dashboard from "./components/pages/dashboard/dashboard";
import OrganisationAdmin from "./components/pages/organisationAdmin/organisationAdmin";
import EditOrganisationProfile from "./components/pages/organisationAdmin/editOrganisationProfile";
import InviteToCourse from "./components/pages/inviteToCourse/inviteToCourse";
import PrivateLayout from "./components/shared/privateLayout";
import MyProfile from "./components/pages/myProfile/myProfile";
import ManageUser from "./components/pages/manageUser/manageUser";
import LearningSpace from "./components/pages/learningSpace/learningSpace";
import EditProfile from "./components/pages/manageUser/editProfile";
import CourseDetails from "./components/pages/courseDetails/courseDetails";
import AcceptInvitationComponent from "./components/layouts/accept_invitation";
import AcceptInvitationOrgComponent from "./components/layouts/accept_org_invitation";
import Stats from "./components/pages/dashboard/Stats";
import Messages from "./components/messages";
import TemplateLibrary from "./components/pages/organisationAdmin/templateLibrary";
import Compliance from "./components/pages/organisationAdmin/compilance";
import DocumentUploadCenter from "./components/pages/organisationAdmin/documentUploadCenter";
import IcFAQPage from "./components/pages/organisationAdmin/icFaq";
import AdminFAQPage from "./components/pages/organisationAdmin/adminFaq";


import MicroModule from "./components/pages/microModule/microModule";
import ViewUser from "./components/pages/viewUser/viewUser";
import CaseStudies from "./components/pages/caseStudie/caseStudie";
import CaseStudieDetail from "./components/pages/caseStudie/caseStudieDetail";
import IcTemplate from "./components/pages/icTemplate/icTemplate";
import MicroModuleStats from "./components/pages/dashboard/microModuleStats";
import MicroModuleDashboard from "./components/pages/microModuleDashboard/microModuleDashboard";
import Loader from "./components/layouts/loader";
import apiService from './services/apiService';


export default function AppRoutes() {
    const [adminRole, setAdminRole] = useState(localStorage.getItem('adminRole'));
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);

    
    // Listen for changes in localStorage
    useEffect(() => {
        const handleStorageChange = () => {
            setAdminRole(localStorage.getItem('adminRole'));
        };
        
        // Initial check and set loading to false after a small delay
        const initialRole = localStorage.getItem('adminRole');
        setAdminRole(initialRole);
        
        // Add a small delay to ensure localStorage is properly set
        const loadingTimeout = setTimeout(() => {
            setIsLoading(false);
        }, 100);
        
        // Listen for storage events
        window.addEventListener('storage', handleStorageChange);
        
        // Also check periodically in case localStorage is updated within the same tab
        const interval = setInterval(() => {
            const currentRole = localStorage.getItem('adminRole');
            if (currentRole !== adminRole) {
                setAdminRole(currentRole);
            }
        }, 1000);
        
        return () => {
            clearTimeout(loadingTimeout);
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(interval);
        };

        
    }, [adminRole]);

     useEffect(() => {
        fetchData();
    }, []);

     const fetchData = async () => {
        try {
            const token = apiService.getAuthToken()
            const result = await apiService.get('get-org-user-info', token);
            if (result && result?.status == "success") {
                setUserData(result?.data);
            }
        } catch (error) {
            setError('Error fetching user data');
            console.error(error);
        }
    };
    
    console.log("Admin Role:", adminRole);
    
    // Component to render based on user role
    const IndexComponent = () => {
        // Show loading state while determining role
        if (isLoading) {
            return <Loader />; // You can replace this with a proper loader component
        }
        
        // Get current role from localStorage as a backup
        const currentRole = localStorage.getItem('adminRole');
        const roleToUse = adminRole || currentRole;

        if (userData?.orgIcType === 'ic') {
            return <Navigate to='/learning_space' />;
        } 
        else if (userData?.orgIcType === 'org' || userData?.orgIcType === 'both' || userData?.orgIcType === 'null' || userData?.orgIcType === null) {
            return <Navigate to='/dashboard' />;
        }
        //  else {
        //     return <Navigate to='/dashboard' />;
        // }
    };
    
    return (
        <Router>
            <Routes>
                <Route
                    path="/"
                    element={<DashboardLayout />}
                >
                    <Route index element={<IndexComponent />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/stats/:course_id/:course_name/:org_course_id" element={<Stats />} />
                    <Route path="/learning_space" element={<LearningSpace />} />
                    <Route path="/organisation_admin" element={<OrganisationAdmin />} />
                    <Route path="/manage_user" element={<ManageUser />} />
                    <Route path="/compliance/:id" element={<Compliance />} />
                    <Route path="/document_upload_center" element={<DocumentUploadCenter />} />
                    <Route path="/template_library" element={<TemplateLibrary />} />
                    <Route path="/template_library/:category" element={<TemplateLibrary />} />
                    <Route path="/faq_page" element={adminRole === 'org-dash' ? <AdminFAQPage /> : <IcFAQPage />} />

                    <Route path="/micro_module" element={<MicroModule />} />
                    <Route path="/view_user" element={<ViewUser />} />
                    <Route path="/case_studie" element={<CaseStudies />} />
                   
                    <Route path="/ic_template_library" element={<IcTemplate />} />
                    <Route path="/micro-modules-stats" element={<MicroModuleStats />} />
                </Route>

                <Route
                    path="/"
                    element={<PrivateLayout />}
                >
                    <Route path='/course_invite' element={<InviteToCourse />}></Route>
                    <Route path='/my_profile' element={<MyProfile />}></Route>
                    <Route path='/edit_org_profile' element={<EditOrganisationProfile />}></Route>
                    <Route path='/manage_user/edit_profile' element={<EditProfile />}></Route>
                    <Route path='/learning_space/course_details/:id' element={<CourseDetails />}></Route>
                    <Route path='/micro_module/course_modules/:id' element={<MicroModuleDashboard />}></Route>
                    <Route path="/case-study/:id" element={<CaseStudieDetail />} />
                </Route>

                <Route
                    path="/"
                    element={<PublicRoutesLayout />}
                >
                    <Route path="/accept-invitation" element={<AcceptInvitationComponent />}> </Route>
                    <Route path="/accept-org-invitation" element={<AcceptInvitationOrgComponent />}> </Route>
                    <Route path="/messages" element={<Messages />}></Route>

                </Route>

            </Routes>
        </Router>
    );
}

